import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import { UiCol, UiGridColOne, UiGridColTwo } from '../../../../library/layout/Index';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormAttachment from '../../../../library/form/components/FormAttachment';

const StockCheckListPhysicalEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    const countStatusObj = formObject.getFormData("", "", "countStatus");
    const countStatus = formObject.getValueFromKey(countStatusObj, "val", "");
    // console.log("StockCheckRow EDITOR", viewData, countStatus);

    const actionObj = countStatus === "readonly"
        ? {
            actionParam: { actionType: '' },
            formActions: { forAction: "", forCancel: "Close" }
        }
        : countStatus === "count" ? {
            actionParam: { actionType: 'updatePhysicalCount' },
            refreshMode: "self",
            formActions: { forAction: "Confirm", forCancel: "Cancel" }
        } : {
            actionId: "refresh",
            closeOnAction: false,
            actionParam: { actionType: 'resetPhysicalCount' },
            formActions: { forAction: "Count Again", forCancel: "Cancel" }
        };

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={actionObj}
            contentStyle={{ height: '300px' }}
            formStyle={{ width: '535px', height:"450px" }} formTitle={<SarasTrans value="Physical Count" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <UiGridColTwo>
                                <UiCol>
                                    <ul>
                                        <li>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "itemId" }} className=""/> /
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "pItemId" }} className="uiSpacerH5"/>
                                        </li>
                                        <li>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "itemName" }}/>
                                        </li>
                                        <li>
                                            <span className="uiLbl">
                                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "systemCount" }} value="System Count" />
                                            </span>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "systemCount" }} className="uiSpacerH10"/>
                                        </li>
                                    </ul>
                                </UiCol>
                                <UiCol>
                                    <div style={{ margin: "3px auto", width: "100%", backgroundColor: "#fff", textAlign: "center", minHeight: "60px" }}>
                                        <FormAttachment style={{ cursor: "pointer", maxWidth: "50%", maxHeight: "60px" }} formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "itemImage" }} />
                                    </div>
                                </UiCol>
                            </UiGridColTwo>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "physicalCount1" }} value="Physical Count 1" />
                            </span>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", actionId: "refresh", paramName: "physicalCount1", actionParam:{actionType:"updateUsableQty"} }}
                                className='uiSpacerH10'/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "physicalCount2" }} value="Physical Count 2" />
                            </span>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                                action={{ InputType: "input", actionId: "refresh", paramName: "physicalCount2", actionParam:{actionType:"updateUsableQty"} }} className='uiSpacerH10'/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }}/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notUsableCount1" }} value="Cannot Use 1" />
                            </span>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", actionId: "refresh", paramName: "notUsableCount1", actionParam:{actionType:"updateUsableQty"} }}
                                className='uiSpacerH10'/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notUsableCount2" }} value="Cannot Use 2" />
                            </span>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                                action={{ InputType: "input", actionId: "refresh", paramName: "notUsableCount2", actionParam:{actionType:"updateUsableQty"} }} className='uiSpacerH10'/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }}/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "usableCount" }} value="Usable Count" />
                            </span>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "usableCount" }} className="uiSpacerH10"/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comment" />
                            </span>
                            <FormInput style={{width:"250px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", paramName: "comment", actionParam:{} }}
                                className='uiSpacerH10'/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "storeLocation" }} value="Store Location" />
                            </span>
                            <FormInput style={{width:"250px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", paramName: "storeLocation", actionParam:{} }}
                                className='uiSpacerH10'/>
                        </li>
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(StockCheckListPhysicalEditor, "stockCheckListPhysical", "stockCheckListPhysical,stockCheckListSystem")